import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./core/services/store";
import ApiService from "./core/services/api.service";
// import MockService from "./core/mock/mock.service";
import { VERIFY_AUTH } from "./core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import { CLEAR_ACTION } from "@/core/services/store/actions.module";

const moment = require("moment");
require("moment/locale/id");
moment.locale("id");

Vue.use(require("vue-moment"), {
  moment
});

Vue.config.productionTip = false;

// workaround
// https://github.com/vuetifyjs/vuetify/issues/9999
const ignoreWarnMessage = `The .native modifier for v-on is only valid on components but it was used on <div>.`;
// eslint-disable-next-line no-unused-vars
Vue.config.warnHandler = function(msg, vm, trace) {
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
};
// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "./core/plugins/vue-i18n";
import vuetify from "./core/plugins/vuetify";
import DisableAutocomplete from "@aacassandra/vue-disable-autocomplete";
import DatePicker from "vue2-datepicker";
import * as VueGoogleMaps from "vue2-google-maps";
// import VueVideoPlayer from "vue-video-player";
import VueSweetalert2 from "vue-sweetalert2";
import OneSignalVue from "onesignal-vue";
import InfiniteLoading from "vue-infinite-loading";

import "./core/plugins/portal-vue";
import "./core/plugins/bootstrap-vue";
import "./core/plugins/perfect-scrollbar";
import "./core/plugins/highlight-js";
import "./core/plugins/inline-svg";
import "./core/plugins/apexcharts";
import "./core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import DatetimePicker from "vuetify-datetime-picker";
import CurrencyInput from "./view/component/CurrencyInput.vue";

Vue.component("CurrencyInput", CurrencyInput);

// API service init
ApiService.init();
Vue.use(DisableAutocomplete);
Vue.use(DatePicker);
Vue.use(DatetimePicker);
// Vue.use(VueVideoPlayer);
Vue.use(VueSweetalert2);
Vue.use(OneSignalVue);
Vue.use(InfiniteLoading);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCRYGxj8hvfJnxR449J-1hcvO0Dmooh5FM"
    // libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

// Remove this to disable mock API
// MockService.init();

router.beforeEach((to, from, next) => {
  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);
  store.dispatch(CLEAR_ACTION);
  // Ensure we checked auth before each page load.
  store.dispatch(VERIFY_AUTH).then(status => {
    if (!status && ["login", "register"].indexOf(to.name) == -1) {
      if (to.redirectedFrom == "/admin") {
        next({ name: "login" });
      } else {
        next({ to: "/" });
      }
    } else {
      next();
    }
  });

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
